"use strict";

require("./libs/utils.js");

var _setup = require("./setup.js");

var _ticker = require("./ticker.js");

var _lazyLoad = require("./libs/lazy-load.js");

var _lazyLoad2 = _interopRequireDefault(_lazyLoad);

require("./page-loader.js");

require("./global-ui.js");

require("./menu-overlay.js");

require("./menu-dropdowns.js");

require("./hero-carousel.js");

require("./video-players.js");

require("./product-lists.js");

require("./product-single.js");

require("./blogs.js");

require("./cart-panel.js");

require("./account.js");

require("./search.js");

require("./temp.js");

require("./backupLazyLoader");

var _ajaxCart = require("./ajax-cart.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import 'babel-polyfill';

//jquery plugs, polyfills, etc...
if (!(0, _setup.supportsClipPath)()) {
  _setup.s.$body.addClass("no-clippath-support");
}

//global elements & state

if ((0, _setup.detectIE)()) {
  _setup.s.$body.addClass("is-ms-browser");
}

//workflow tools (remove for final production)
//import {livereload} from './live-reload.js';
//import {styleguide} from './styleguide-only.js';

//ticker/raf-based animations

//lazy loading images

_setup.s.$flickityLazyloads.addClass("is-lazyload-other");

_setup.s.$window.on("nx.page.loaded", function () {
  new _lazyLoad2.default();
  _ticker.ticker.call();
});

//actual module js


//language dropdown
//import './lang-menu-drop.js';

_ajaxCart.ajaxCart.init();
_ajaxCart.ajaxCart.load();

//non-production functionality
//console.log(s.isdev);

// if (s.isdev) {
// 	livereload.call();
// }

// if (s.isstyleguide) {
// 	styleguide.call();
// }


//////////////////
// WEBPACK FOOTER
// ./_js/app.js
// module id = 6
// module chunks = 0